import * as React from 'react';
import './style/index.scss';
export const DetailsCard = (props) => {
    const { className, title, children } = props;
    return (React.createElement("div", { className: `details-card ${className || ''}` },
        title && React.createElement("div", { className: "details-card__header" }, title),
        React.createElement("div", { className: "details-card__body" }, children)));
};
export default DetailsCard;
